import * as React from "react"
const Location = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#333"
      d="M8 0a5.801 5.801 0 0 0-5.794 5.795c0 3.965 5.185 9.786 5.406 10.032.207.23.57.23.776 0 .221-.246 5.407-6.067 5.407-10.032C13.795 2.599 11.195 0 8 0Zm0 8.71a2.919 2.919 0 0 1-2.915-2.915A2.919 2.919 0 0 1 8 2.879a2.919 2.919 0 0 1 2.915 2.916A2.919 2.919 0 0 1 8 8.71Z"
    />
  </svg>
)
export default Location